<template>
<div class="logistics">
	<div class="modal-window">
		<div class="modal-content">
			<grid>
				<div alt="logo" class="logo" />
			</grid>
			<router-view></router-view>
			<hr>
			<button class="button primary" @click="goToOpportunity()">
				find flights
			</button>
		</div>
	</div>
	<a @click="goToOpportunity()" class="back-button">
		X
	</a>
</div>
</template>

<script>
export default {
	methods: {
		goToOpportunity() {
			this.$router.push({
				name: 'opportunity',
				hash: '#LogisticTab',
				params: {
					opportunityId: this.$route.query.opportunityId
				},
				query: {
					...this.$route.query,
					opportunityId: undefined
				}
			})
		}
	}
}
</script>

<style lang="scss">
.logistics {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 56px;
	right: 0;
	z-index: 3;
	background: #0202029c;

	.modal-window {
		top: 35% !important;
		left: 48% !important;
		width: 40% !important;
		
		h3 {
			color: #fff;
			font-size: 13px;
			text-transform: uppercase;
		}
		.modal-content {
			background-image: radial-gradient(
				circle at 50% 50%, 
				rgba(255, 255, 255, 0.36) 25%, 
				rgba(53, 74, 90, 0.39) 70%
			);
			padding-bottom: 15px;
			padding-top: 10px;
			border-color: rgba(255, 255, 255, 0.66);

			.logo {
				background: url('../../../../assets/images/logo_light.svg');
				background-repeat: no-repeat;
				background-size: cover;
				background-position: center;
				width: 100px;
				margin: 0 auto;
			}

			.logistic-content {
				background: #151a228f;
				padding: 10px 20px;

				p {
					margin: 0 0 2px;
					text-align: left;
					color: #fff;
					font-size: 14px;
				}
				.nearby-button {
					color: #999999;
					border: 1px solid #8a8c91;
					padding: 5px 10px;
					border-radius: 15px;
					margin: 5px 5px 7px 0px;
					user-select: none;
					cursor: pointer;
					float: left;
					text-transform: uppercase;
					font-size: 10px;
				}
			}
		}
		hr {
			margin: 15px;
			width: 520px;
			margin-left: -40px;
		}
		.button {
			width: 150px;
			padding: 4px 13px;
			margin: 4px 0px;
		}
	}

	.back-button {
		position: absolute;
		top: 0;
		right: 0;
		text-decoration: none;
		color: #fff;
		background: #3b9fcf;
		width: 55px;
		height: 55px;
		line-height: 55px;
		font-size: 36px;
		font-weight: 200;
		cursor: pointer;
	}
}
</style>
